import React, { ComponentType } from "react"
import { NodeProps } from "reactflow"

import { BlockNodeData } from "@/protocols/chatBotFlow"

import useChatBotFlowBlockDetails from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/hooks/useChatBotFlowBlockDetails"

import BaseBlock from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BaseBlock"
import BlockBodySection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySection"
import BlockBodySectionGroup from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionGroup"
import AIIntentionSectionEditor from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/resources/Blocks/AIIntentionBlock/AIIntentionSectionEditor"
import BlockBodySectionHandle from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionHandle"
import CreateConditionButton from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/CreateConditionButton"
import ElseConditionSection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/ElseConditionSection"
import WithoutAICreditsConditionSection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/resources/Blocks/AIConditionBlock/WithoutAICreditsConditionSection"
import AIIntentionSectionContainer from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/resources/Blocks/AIIntentionBlock/AIIntentionSectionContainer"

import { getConditionRuleByValidationSlug, getContinueConditionRuleFormattedForCreation } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/utils/chatBotFlowBlockRule"
import { generateUUID } from "@/utils/id"

const AIIntentionBlock: ComponentType<NodeProps<BlockNodeData>> = (node) => {
	const chatBotFlowBlockDetails = useChatBotFlowBlockDetails({ chatBotFlowBlockId: node.data.chatBotFlowBlockId })

	const aiConditionMatchRules = chatBotFlowBlockDetails.nextChatBotFlowBlockRules.filter((nextChatBotFlowBlockRule) => getConditionRuleByValidationSlug("ai-condition-match", [nextChatBotFlowBlockRule]))

	return (
		<BaseBlock
			node={node}
		>
			<BlockBodySectionGroup>
				{aiConditionMatchRules.map(rule => (
					<BlockBodySection
						key={rule.id}
						fullWidth
					>
						<BlockBodySectionHandle
							chatBotFlowBlockRule={rule}
						>
							<AIIntentionSectionEditor
								onSave={(chatBotFlowBlockRule) => chatBotFlowBlockDetails.changeRule("UPDATE", chatBotFlowBlockRule)}
								onDelete={() => chatBotFlowBlockDetails.changeRule("DELETE", rule)}
								chatBotFlowBlockRule={rule}
							>
								<AIIntentionSectionContainer
									chatBotFlowBlockRule={rule}
									chatBotFlowBlockId={node?.data?.chatBotFlowBlockId}
								/>
							</AIIntentionSectionEditor>
						</BlockBodySectionHandle>
					</BlockBodySection>
				))}
			</BlockBodySectionGroup>

			<BlockBodySection>
				<AIIntentionSectionEditor
					hideChildSelection
					onSave={(chatBotFlowBlockRule) => (
						chatBotFlowBlockDetails.changeRule("CREATE", {
							...chatBotFlowBlockRule,
							id: generateUUID(),
							next_chat_bot_flow_block_id: null,
							validations: chatBotFlowBlockRule?.validations || []
						})
					)}
					chatBotFlowBlockRule={(
						getContinueConditionRuleFormattedForCreation(
							chatBotFlowBlockDetails.blockConstructionResource?.available_next_block_flow_rules,
							"ai-condition-match"
						)
					)}
				>
					<CreateConditionButton
						color={chatBotFlowBlockDetails.blockThemeConfig.color.blockIcon}
						chatBotFlowBlockId={node?.data?.chatBotFlowBlockId}
					>
						Adicionar intenção
					</CreateConditionButton>
				</AIIntentionSectionEditor>
			</BlockBodySection>

			<ElseConditionSection
				nextChatBotFlowBlockRules={chatBotFlowBlockDetails.nextChatBotFlowBlockRules}
				text="Se nenhuma intenção for identificada"
			/>
			<WithoutAICreditsConditionSection
				nextChatBotFlowBlockRules={chatBotFlowBlockDetails.nextChatBotFlowBlockRules}
				text="Se os créditos de IA acabarem"
			/>
		</BaseBlock>
	)
}

export default AIIntentionBlock
